import { TranslatedMessage } from '@library/react-toolkit'
import { Badge, Typography } from 'antd'
import React from 'react'
import styled from 'styled-components'

const FinancingStatusWrapper = styled.div`
  left-margin: 10px;
`

type FinancingStatusProps = {
  status: string
}

export const FinancingStatus = ({ status }: FinancingStatusProps) => {
  console.log(status)

  return (
    <FinancingStatusWrapper>
      {
        {
          Published: (
            <Badge
              status="warning"
              text={
                <Typography.Text type="warning">
                  <TranslatedMessage id={status} />
                </Typography.Text>
              }
            />
          ),
          Financed: (
            <Badge
              status="success"
              text={
                <Typography.Text type="success">
                  <TranslatedMessage id={status} />
                </Typography.Text>
              }
            />
          ),
          'Pending Offers': (
            <Badge
              status="warning"
              text={
                <Typography.Text type="warning">
                  <TranslatedMessage id={status} />
                </Typography.Text>
              }
            />
          ),
        }[status]
      }
    </FinancingStatusWrapper>
  )
}
